@import "leaflet/dist/leaflet.css";

.mvMapWrapper {
    display: flex;
    flex-grow: 1;
    background-color: grey;
    width: 100%;
    height: 40%;

    :global(.crosshair-cursor-enabled) {
        cursor: crosshair;
    }

    /**
     * Make sure cursor does not change when hovering over marker objects */
    :global(.crosshair-cursor-enabled .leaflet-interactive) {
        cursor: crosshair;
    }

    :global(.icon-drag) {
        cursor: grab;
    }

    @media screen and (min-width: 768px) {
        width: 50%;
        height: 100%;
    }
}

.addMarkerButton {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    box-shadow: 10px 10px 39px 0px rgba(0, 0, 0, 0.24);
    z-index: 999;
    font-size: 1.1rem;
    padding: 1rem 1.3rem;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    span {
        position: absolute;
        font-weight: normal;
        margin-top: -0.35rem;
        margin-left: 0.15rem;
    }
}

.addMarkerIcon {
    width: 1rem;
}

.addMarkerCloseIcon {
    width: 1rem;
}

.loadingOverlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.4);
    display: none;

    &.loadingShow {
        display: flex;
    }
}

.loadingOverlayIcon {
    width: 60px;
}

.addMarkerMessage {
    background-color: #cb0000;
    color: white;
    border-radius: 5px;
    position: absolute;
    bottom: 1rem;
    z-index: 1001;
    left: 50%;
    padding: 0.5rem 1rem;
    transform: translate(-50%, 200%);
    transition: transform 0.3s ease-in-out;

    &.showMessage {
        transform: translate(-50%, 0);
    }
}
